import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomanglorecab() {



    const cardData = {




keyword: "Belgaum to Mangalore Cab",

headingDescription: "Belgaum Taxi Service offers comfortable and reliable Belgaum to Mangalore cab services for business travel, family trips, medical visits, educational purposes, airport transfers, and leisure journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Mangalore, we provide safe and convenient transportation with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel needs. Our services include doorstep pickup, flexible travel schedules, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service connects passengers between Belgaum and Mangalore with comfortable outstation cab solutions for tourists, families, corporate travelers, and individuals looking for hassle-free travel across Karnataka.",

topPlaces: [
  {
    title: "Mangalore Airport",
    description: "Mangalore Airport is an important travel hub for passengers visiting coastal Karnataka. Belgaum to Mangalore airport cabs provide convenient pickup and drop facilities for business and leisure travelers."
  },
  {
    title: "Panambur Beach",
    description: "Panambur Beach is one of Mangalore's most popular beaches known for sunsets, water activities, and peaceful seaside views, making it a favorite tourist attraction."
  },
  {
    title: "Kudroli Gokarnanatheshwara Temple",
    description: "Kudroli Temple is a famous spiritual landmark in Mangalore known for beautiful architecture, festivals, and religious importance."
  },
  {
    title: "St. Aloysius Chapel",
    description: "St. Aloysius Chapel is a historic attraction in Mangalore famous for its stunning paintings, heritage value, and unique architecture."
  },
  {
    title: "Udupi",
    description: "Udupi is a popular coastal destination known for Sri Krishna Temple, beaches, traditional cuisine, and cultural attractions, making it a preferred stop near Mangalore."
  },
  {
    title: "Kundapura",
    description: "Kundapura is a scenic coastal town known for beaches, temples, rivers, and natural beauty. It is a popular destination for travelers exploring coastal Karnataka."
  },
  {
    title: "Coorg",
    description: "Coorg is a beautiful hill station famous for coffee plantations, waterfalls, forests, and pleasant weather, attracting families and tourists throughout the year."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business hub with corporate offices, technology parks, and commercial centers. Long-distance cabs provide comfortable connectivity."
  },
  {
    title: "Goa",
    description: "Goa is a famous holiday destination known for beaches, resorts, churches, and sightseeing attractions. Private cabs offer a comfortable travel option for leisure trips."
  },
  {
    title: "Mysore",
    description: "Mysore is a heritage city famous for Mysore Palace, Chamundi Hills, cultural attractions, and royal history, making it a popular tourist destination in Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Mangalore Cab",
    "description": "Book Belgaum to Mangalore Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for business trips, family journeys, airport transfers, and long-distance travel with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Mangalore Taxi",
    "description": "Hire Belgaum to Mangalore Taxi service for a smooth and convenient journey with experienced drivers, clean cars, affordable fares, and doorstep pickup facilities. Travel comfortably between Belgaum and Mangalore with reliable chauffeur-driven taxis available for personal, corporate, and family trips."
  },
  {
    "name": "Belgaum to Mangalore Cab Service",
    "description": "Choose Belgaum to Mangalore Cab Service for hassle-free intercity transportation with premium vehicles, trained drivers, transparent pricing, and 24x7 booking support. Our cab services are ideal for airport travel, sightseeing tours, business visits, and comfortable outstation journeys."
  },
  {
    "name": "Belgaum to Mangalore Taxi Service",
    "description": "Book Belgaum to Mangalore Taxi Service for affordable and convenient travel solutions. Enjoy comfortable AC taxis, professional chauffeurs, flexible travel schedules, and reliable pickup and drop services for individuals, families, and corporate passengers."
  },
  {
    "name": "Belgaum to Mangalore One Way Cab",
    "description": "Get Belgaum to Mangalore One Way Cab at affordable rates without return fare charges. Travel with clean vehicles, experienced drivers, fixed pricing, and comfortable seating options for a stress-free single-trip journey."
  },
  {
    "name": "Belgaum to Mangalore Cab Booking",
    "description": "Complete Belgaum to Mangalore Cab Booking online with easy reservations, quick confirmation, multiple vehicle options, and professional driver assistance. Book Sedan, Ertiga, Innova Crysta, and SUV cabs according to your travel requirements."
  },
  {
    "name": "Belgaum to Mangalore Car Rental",
    "description": "Choose Belgaum to Mangalore Car Rental for comfortable and flexible travel with chauffeur-driven vehicles. Get reliable rental cars for family trips, corporate travel, airport transfers, and long-distance journeys with affordable packages."
  },
  {
    "name": "Belgaum to Mangalore Outstation Cab",
    "description": "Book Belgaum to Mangalore Outstation Cab for safe and comfortable long-distance travel. Enjoy well-maintained AC vehicles, experienced drivers, flexible one way and round trip options, and convenient doorstep pickup services."
  },
  {
    "name": "Belgaum to Mangalore Airport Cab",
    "description": "Reserve Belgaum to Mangalore Airport Cab for timely airport transfers with professional drivers and comfortable vehicles. Get reliable pickup and drop services from Belgaum to Mangalore Airport with Sedan, SUV, Ertiga, and Innova Crysta options."
  },
  {
    "name": "Belgaum to Mangalore Airport Taxi",
    "description": "Book Belgaum to Mangalore Airport Taxi for punctual airport transportation with affordable fares and comfortable travel. Our airport taxi service provides smooth transfers for business travelers, families, and passengers with flight schedules."
  },
  {
    "name": "Belgaum to Mangalore Innova Crysta Cab",
    "description": "Hire Belgaum to Mangalore Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, large luggage space, experienced chauffeurs, and a comfortable journey for families, corporate groups, and outstation passengers."
  },
  {
    "name": "Belgaum to Mangalore Ertiga Cab",
    "description": "Book Belgaum to Mangalore Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors and professional drivers. Perfect for family trips, group travel, airport transfers, and weekend journeys."
  },
  {
    "name": "Belgaum to Mangalore Sedan Cab",
    "description": "Choose Belgaum to Mangalore Sedan Cab for economical and comfortable transportation. Travel in clean AC sedan cars with experienced chauffeurs suitable for business travel, airport transfers, and personal trips."
  },
  {
    "name": "Belgaum to Mangalore Round Trip Cab",
    "description": "Hire Belgaum to Mangalore Round Trip Cab for return journeys with affordable packages and flexible schedules. Ideal for sightseeing, family vacations, business visits, and planned travel between both cities."
  },
  {
    "name": "Belgaum to Mangalore Private Taxi",
    "description": "Book Belgaum to Mangalore Private Taxi for personalized travel with dedicated vehicles and professional drivers. Enjoy privacy, comfort, and flexible travel options for family, corporate, and personal transportation needs."
  },
  {
    "name": "Cheap Belgaum to Mangalore Cab",
    "description": "Find Cheap Belgaum to Mangalore Cab services with budget-friendly fares, reliable vehicles, and quality chauffeur service. Get affordable travel solutions without compromising safety, comfort, and timely service."
  },
  {
    "name": "Best Belgaum to Mangalore Cab Service",
    "description": "Choose the Best Belgaum to Mangalore Cab Service offering premium vehicles, experienced drivers, affordable pricing, and reliable customer support. Enjoy a smooth and comfortable outstation travel experience."
  },
  {
    "name": "Online Belgaum to Mangalore Cab Booking",
    "description": "Complete Online Belgaum to Mangalore Cab Booking with simple booking steps, instant confirmation, and multiple car options. Enjoy convenient taxi reservations for one way trips, round trips, and airport transfers."
  },
  {
    "name": "Belgaum to Mangalore Taxi Fare",
    "description": "Check Belgaum to Mangalore Taxi Fare and choose affordable cab packages based on your vehicle requirements. Get transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV taxis."
  },
  {
    "name": "Belgaum to Mangalore Car Hire",
    "description": "Hire Belgaum to Mangalore Car Rental vehicles with professional drivers and flexible packages. Suitable for family travel, corporate trips, airport transfers, and long-distance journeys."
  },
  {
    "name": "Belgaum to Mangalore Cab Price",
    "description": "Get affordable Belgaum to Mangalore Cab Price with transparent rates and multiple vehicle choices. Book comfortable AC cabs according to your travel budget and requirements."
  },
  {
    "name": "Belgaum to Mangalore Taxi Booking",
    "description": "Book Belgaum to Mangalore Taxi Booking online for quick and convenient travel arrangements. Enjoy reliable service, clean vehicles, experienced chauffeurs, and doorstep pickup facilities."
  },
  {
    "name": "Belgaum to Mangalore Family Cab",
    "description": "Choose Belgaum to Mangalore Family Cab for safe and comfortable family journeys. Travel with spacious vehicles, professional drivers, and flexible travel options for vacations and personal trips."
  },
  {
    "name": "Belgaum to Mangalore Corporate Cab",
    "description": "Book Belgaum to Mangalore Corporate Cab services for business travel, executive transportation, and official meetings. Get premium vehicles with professional chauffeurs and reliable travel support."
  },
  {
    "name": "Belgaum to Mangalore Airport Transfer",
    "description": "Get Belgaum to Mangalore Airport Transfer service with punctual pickup, comfortable vehicles, and professional drivers. Enjoy smooth airport transportation with hassle-free booking options."
  },
  {
    "name": "Belgaum to Mangalore Cab Fare",
    "description": "Know Belgaum to Mangalore Cab Fare with affordable and transparent pricing options. Select from different vehicle categories based on your passenger count and travel requirements."
  },
  {
    "name": "Belgaum to Mangalore Taxi Near Me",
    "description": "Find Belgaum to Mangalore Taxi Near Me for quick booking and reliable outstation travel. Get nearby cab availability with professional drivers and comfortable vehicles."
  },
  {
    "name": "Belgaum to Mangalore Private Cab",
    "description": "Book Belgaum to Mangalore Private Cab for a comfortable and personalized journey. Enjoy exclusive vehicle service, experienced chauffeurs, and flexible travel arrangements."
  }
],
"tableData": [
  ["Belgaum to Mangalore Cab", "Belgaum to Mangalore Taxi"],
  ["Belgaum to Mangalore Cab Service", "Belgaum to Mangalore Taxi Service"],
  ["Belgaum to Mangalore One Way Cab", "Belgaum to Mangalore Cab Booking"],
  ["Belgaum to Mangalore Car Rental", "Belgaum to Mangalore Outstation Cab"],
  ["Belgaum to Mangalore Airport Cab", "Belgaum to Mangalore Airport Taxi"],
  ["Belgaum to Mangalore Innova Crysta Cab", "Belgaum to Mangalore Ertiga Cab"],
  ["Belgaum to Mangalore Sedan Cab", "Belgaum to Mangalore Round Trip Cab"],
  ["Belgaum to Mangalore Private Taxi", "Cheap Belgaum to Mangalore Cab"],
  ["Best Belgaum to Mangalore Cab Service", "Online Belgaum to Mangalore Cab Booking"],
  ["Belgaum to Mangalore Taxi Fare", "Belgaum to Mangalore Car Hire"],
  ["Belgaum to Mangalore Cab Price", "Belgaum to Mangalore Taxi Booking"],
  ["Belgaum to Mangalore Family Cab", "Belgaum to Mangalore Corporate Cab"],
  ["Belgaum to Mangalore Airport Transfer", "Belgaum to Mangalore Cab Fare"],
  ["Belgaum to Mangalore Taxi Near Me", "Belgaum to Mangalore Private Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Smooth Belgaum to Mangalore Cab Journey",
    WhyChoosedescription: "Travel from Belgaum to Mangalore with a convenient taxi service offering comfortable vehicles, skilled drivers, and flexible travel arrangements for every type of passenger."
  },
  {
    WhyChooseheading: "Reliable Intercity Transportation",
    WhyChoosedescription: "Enjoy a hassle-free road journey with direct pickup and drop facilities between Belgaum and Mangalore for personal, business, and leisure travel."
  },
  {
    WhyChooseheading: "Cab Options for Different Needs",
    WhyChoosedescription: "Choose the right vehicle from Sedan, Ertiga, Innova, Innova Crysta, and SUV categories depending on your group size and comfort preference."
  },
  {
    WhyChooseheading: "Suitable for Coastal Trips & Visits",
    WhyChoosedescription: "Our Belgaum to Mangalore taxis are ideal for family holidays, business visits, medical travel, airport transfers, and coastal Karnataka trips."
  },
  {
    WhyChooseheading: "Professional Drivers with Route Knowledge",
    WhyChoosedescription: "Experienced chauffeurs handle the journey with proper route awareness, safe driving practices, and focus on passenger comfort."
  },
  {
    WhyChooseheading: "Flexible Taxi Plans Available",
    WhyChoosedescription: "Select from one-way drops, return journeys, and customized travel options based on your schedule and destination requirements."
  },
  {
    WhyChooseheading: "Comfortable Long Distance Travel",
    WhyChoosedescription: "Clean interiors, spacious seating, and well-maintained cars ensure a pleasant experience during the Belgaum to Mangalore route."
  },
  {
    WhyChooseheading: "Quick Booking Support",
    WhyChoosedescription: "Get assistance for vehicle selection, fare enquiries, and trip planning to make your Belgaum to Mangalore travel simple."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Mangalore Cab Service?",
    answer: "Yes, we offer Belgaum to Mangalore taxi services with comfortable cars and professional drivers for outstation travel."
  },
  {
    question: "Can I hire a one-way taxi from Belgaum to Mangalore?",
    answer: "Yes, one-way cab service is available for travellers who need a direct drop at their destination."
  },
  {
    question: "Which vehicles are available for Belgaum to Mangalore travel?",
    answer: "Available options include Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on passenger requirements."
  },
  {
    question: "Is Belgaum to Mangalore cab suitable for family trips?",
    answer: "Yes, spacious vehicles are available for families with comfortable seating and enough luggage space."
  },
  {
    question: "Can I book a taxi for Mangalore Airport travel?",
    answer: "Yes, airport transfer services are available between Belgaum and Mangalore Airport with planned pickup arrangements."
  },
  {
    question: "Are round-trip cabs available from Belgaum to Mangalore?",
    answer: "Yes, return trip taxi options are available with flexible schedules according to your travel plan."
  },
  {
    question: "Can I use this taxi service for business travel?",
    answer: "Yes, the service is suitable for corporate visits, meetings, official travel, and client transportation."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Additional charges such as tolls, parking, and permits depend on the selected package and are informed during booking."
  },
  {
    question: "Is Belgaum to Mangalore taxi available anytime?",
    answer: "Yes, booking support is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Mangalore Cab?",
    answer: "Provide your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Kulkarni",
    feedback: "The Belgaum to Mangalore taxi service was comfortable and well managed. The driver was experienced, and the vehicle condition was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Deshmukh",
    feedback: "We travelled with family and had a pleasant journey. The cab was spacious, the driver was cooperative, and everything went smoothly.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Mangalore Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-mangalore-cab.webp",
  "description":
    "Book Belgaum to Mangalore Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Mangalore with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, airport transfers, family trips, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-mangalore-cab"
  }
};






    return (
        <div>



<Helmet>
  <title>Belgaum to Mangalore Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Mangalore Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Mangalore with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Mangalore Cab, Belgaum to Mangalore Taxi, Belgaum to Mangalore Cab Service, Belgaum to Mangalore Taxi Service, Belgaum to Mangalore One Way Cab, Belgaum to Mangalore Cab Booking, Belgaum to Mangalore Car Rental, Belgaum to Mangalore Outstation Taxi, Belgaum to Mangalore Taxi Fare, Belgaum Mangalore Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomanglorecab;